.notice {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
  margin: 0 0 var(--space-4);
  padding: var(--space-3) var(--space-4);
  border-radius: var(--radius-md);
  background: var(--info-tint);
  color: var(--text);
  font-size: var(--b-text-body);
  line-height: 1.45;
}

.icon {
  flex: 0 0 auto;
  margin-top: 1px;
  color: var(--info);
}

.body {
  flex: 1 1 auto;
  min-width: 0;
}

.success {
  background: var(--success-tint);
}

.success .icon {
  color: var(--success);
}

.warning {
  background: var(--warning-tint);
}

.warning .icon {
  color: var(--warning);
}

.error {
  background: var(--danger-tint);
}

.error .icon {
  color: var(--danger);
}
